module.exports = "https://99designs-start-assets.imgix.net/js/91a51e15a3c09cbebebbe4f03546f6b3.png";